var NavDomElements = function() {
    this.getMakeModelYearDom = function(parentId) {
        return {
            makesDiv: $( parentId + ' .makes'),
            modelsDiv: $( parentId + ' .models'),
            yearsDiv: $( parentId + ' .years'),
            modelsListDiv: $( parentId + ' .models .list'),
            yearsListDiv: $( parentId + ' .years .list')
        };
    };
};

module.exports = new NavDomElements();


//////////////////
// WEBPACK FOOTER
// ./src/interlock/nav/nav-dom-elements.js
// module id = 24
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14